import { Button } from "@/components/ui/button";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { PoultrySelector } from "./PoultrySelector";
import { CreditPaymentForm } from "./CreditPaymentForm";
import { PaymentMethodSelector } from "@/components/stock/cart/PaymentMethodSelector";

interface TransactionContentProps {
  selectedPoultry: any[];
  onPoultrySelect: (poultry: any[]) => void;
  isCredit: boolean;
  onCreditChange: (value: boolean) => void;
  partialPayment: string;
  onPartialPaymentChange: (value: string) => void;
  customerName: string;
  onCustomerNameChange: (value: string) => void;
  customerContact: string;
  onCustomerContactChange: (value: string) => void;
  paymentDate: string;
  onPaymentDateChange: (value: string) => void;
  customerSignature: string;
  onCustomerSignatureChange: (value: string) => void;
  customerAddress: string;
  onCustomerAddressChange: (value: string) => void;
  total: number;
  onConfirm: () => void;
  onClose: () => void;
  paymentMethod: string;
  onPaymentMethodChange: (method: string) => void;
}

export const TransactionContent = ({
  selectedPoultry,
  onPoultrySelect,
  isCredit,
  onCreditChange,
  partialPayment,
  onPartialPaymentChange,
  customerName,
  onCustomerNameChange,
  customerContact,
  onCustomerContactChange,
  paymentDate,
  onPaymentDateChange,
  customerSignature,
  onCustomerSignatureChange,
  customerAddress,
  onCustomerAddressChange,
  total,
  onConfirm,
  onClose,
  paymentMethod,
  onPaymentMethodChange,
}: TransactionContentProps) => {
  const { data: stockItems = [] } = useQuery({
    queryKey: ["stockItems"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('stock_items')
        .select('*')
        .gt('quantity', 0);

      if (error) throw error;
      return data;
    },
  });

  return (
    <div className="space-y-6">
      <PoultrySelector
        stockItems={stockItems}
        onPoultrySelect={onPoultrySelect}
      />

      {selectedPoultry.length > 0 && (
        <>
          <div className="text-lg font-semibold">
            Total: {total.toLocaleString()} FCFA
          </div>

          <PaymentMethodSelector
            selectedMethod={paymentMethod}
            onMethodChange={onPaymentMethodChange}
          />

          <CreditPaymentForm
            totalAmount={total}
            isCredit={isCredit}
            onCreditChange={onCreditChange}
            partialPayment={partialPayment}
            onPartialPaymentChange={onPartialPaymentChange}
            customerName={customerName}
            onCustomerNameChange={onCustomerNameChange}
            customerContact={customerContact}
            onCustomerContactChange={onCustomerContactChange}
            paymentDate={paymentDate}
            onPaymentDateChange={onPaymentDateChange}
            customerSignature={customerSignature}
            onCustomerSignatureChange={onCustomerSignatureChange}
            customerAddress={customerAddress}
            onCustomerAddressChange={onCustomerAddressChange}
          />

          <div className="flex justify-end space-x-2">
            <Button variant="outline" onClick={onClose}>
              Annuler
            </Button>
            <Button 
              onClick={onConfirm}
              disabled={!paymentMethod || selectedPoultry.length === 0}
            >
              Confirmer la transaction
            </Button>
          </div>
        </>
      )}
    </div>
  );
};